import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ActivityData } from '../types/activity';

export const getAdminActivities = createAsyncThunk(
    'adminActivities/getAdminActivities',
    async ({ selectionKey, selectionValue, sortBy, reverse, page, pageSize }:
        {
            selectionKey: string,
            selectionValue: string,
            sortBy: string,
            reverse: string,
            page: string,
            pageSize: string
        }) => {
        const token = localStorage.getItem('ticino-wild-token');
        const url = `${process.env.REACT_APP_SERVER_BASE_URL}/activities/admin-activities?selectionKey=${selectionKey}&selectionValue=${selectionValue}&sortBy=${sortBy}&reverse=${reverse}&page=${page}&pageSize=${pageSize}`;
        const headers = {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        };
        const options = {
            method: 'GET',
            headers
        }
        const response = await fetch(url, options);
        if (response.ok) {
            const result = await response.json();
            return result
        } else {
            const error = await response.json();
            throw error;
        };
    }
)

type InitialState = {
    isLoading: boolean,
    error: string | null,
    count: number | null,
    data: ActivityData[] | null,
    isNeedRefresh: boolean
}

const initialState: InitialState = {
    isLoading: false,
    error: null,
    count: null,
    data: null,
    isNeedRefresh: false
}

const adminActivitiesSlice = createSlice({
    name: 'adminActivities',
    initialState,
    reducers: {
        setIsNeedRefresh: (state, action) => {
            state.isNeedRefresh = action.payload
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAdminActivities.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getAdminActivities.fulfilled, (state, action) => {
                state.data = action.payload.payload;
                state.count = action.payload.count;
                state.isLoading = false;
                state.error = null;
                // aggioranre gli altri parametri sortBy, ecc
            })
            .addCase(getAdminActivities.rejected, (state, action) => {
                state.error = action.error.message || "Errore generico";
                state.data = null;
                state.isLoading = false;
            })
    }
})

export const { setIsNeedRefresh } = adminActivitiesSlice.actions;
export default adminActivitiesSlice.reducer;